import { ExchangeError } from '@exodus/exchange-client-providers';
import { safeString } from '@exodus/safe-string';
export class QuoteNotFoundError extends ExchangeError {
    name = safeString `Quote Not Found Error`;
}
